import { route } from '@community_dev/requests'
import { Api } from '@community_dev/types'
import { CommunicationChannel } from '@community_dev/types/lib/api/CommunicationChannel'
import { CampaignDisplayStatus, CampaignType } from '@community_dev/types/lib/api/v2/Campaign'
import { CamelCasedPropertiesDeep } from 'type-fest'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/request'

type CampaignSummary = Pick<
  Api.V2.Campaign,
  | 'id'
  | 'name'
  | 'text'
  | 'communication_channel'
  | 'recipient_count'
  | 'display_status'
  | 'created_at'
  | 'scheduled_at'
> & {
  submitted_at: string
  response_rate?: number | null
  link_click_rate?: number | null
  stop_rate?: number | null
}

export type Campaign = CamelCasedPropertiesDeep<CampaignSummary>
export type PaginatedCampaigns = CamelCasedPropertiesDeep<Api.V2.Pagination<CampaignSummary>>

export function getRecentCampaigns({
  clientId,
  pageSize,
}: {
  clientId: string
  pageSize: number
}): Promise<PaginatedCampaigns> {
  const path = route(
    ENDPOINTS.CAMPAIGNS.LIST,
    { clientId },
    {
      page_number: 1,
      page_size: pageSize,
      communication_channels: Object.values(CommunicationChannel).join(','),
      display_statuses: Object.values(CampaignDisplayStatus).join(','),
      campaign_types: Object.values(CampaignType).join(','),
      direction: 'descending',
      sort_by: 'scheduled_at',
    },
  )
  return request(path)
}
